module.exports = __webpack_public_path__ + "static/4-79fc9b5fbeb6bdda104260ca040c9f45.jpeg";